import React from 'react';
import { ButtonGroupWrapper, ButtonSpan } from './styles';
import messages from '../../../TaskEditorHeader/Messages';
import { blue, green, red, white } from '../../../../utils/style/colors';
import Icon from '../../../Icon/Icon';
import HoverIcon from '../../../HoverIcon/HoverIcon';
import APopover from '../../../APopover';
import { LimitationType } from 'store/limitations/limitationsSlice';
import i18n from '../../../../i18n';

export interface LimitationButtonGroupItem {
  type: LimitationType;
  disabled: boolean;
  selected: boolean;
  fromParent: boolean;
  preventFromParent?: boolean;
  onlyInPart?: boolean;
  titleOverwrite?: string;
}
interface IComponentProps {
  items: LimitationButtonGroupItem[];
  onSelect: (item?: LimitationButtonGroupItem) => void;
  width?: string;
  columnsNumber?: number;
  style?: any;
  loading?: boolean;
}

class ButtonGroup extends React.PureComponent<IComponentProps> {
  state = {
    custom: false,
  };

  handleClickOnItem = (item?: LimitationButtonGroupItem) => () => {
    this.props.onSelect(item);
  };

  render() {
    const { items, width, columnsNumber, style, loading } = this.props;
    const activeIndex = items.findIndex((it) => {
      return it.selected === true;
    });
    return (
      <div style={style}>
        <ButtonGroupWrapper width={width}>
          {items.map((item, index) => {
            const fromOther =
              items.findIndex((it, i) => it.selected && i > index) > 0;
            const fromOtherParent =
              items.findIndex((it, i) => it.fromParent && i > index) > 0;
            const permissionTitle =
              item.titleOverwrite ||
              (i18n.t(`${item.type}`, { ns: 'documentManager' }) as string);
            return (
              <>
                <ButtonSpan
                  key={item.type}
                  isActive={item.selected}
                  onClick={
                    !loading
                      ? this.handleClickOnItem(item)
                      : () => {
                          /**/
                        }
                  }
                  flexBasis={
                    columnsNumber ? (1 / columnsNumber) * 100 : undefined
                  }
                >
                  {
                    <Icon
                      color={
                        item.fromParent || fromOtherParent
                          ? blue
                          : item.selected
                            ? white
                            : fromOther
                              ? green
                              : red
                      }
                      style={{ marginInlineEnd: '5px', fontSize: '2.0em' }}
                      type={
                        item.fromParent ||
                        fromOtherParent ||
                        fromOther ||
                        item.selected
                          ? 'check'
                          : 'x'
                      }
                      title={
                        item.fromParent || fromOtherParent
                          ? i18n.t('activeFromParent', {
                              ns: 'documentManager',
                            })
                          : fromOther
                            ? i18n.t('activeFromHigherPermission', {
                                ns: 'documentManager',
                              })
                            : item.selected
                              ? i18n.t('active', {
                                  ns: 'documentManager',
                                })
                              : i18n.t('inactive', {
                                  ns: 'documentManager',
                                })
                      }
                    />
                  }
                  <APopover
                    arrow
                    curveBorder={true}
                    target={
                      <span>
                        {permissionTitle}
                        {item.onlyInPart
                          ? ' ' +
                            i18n.t('onlyInPart', {
                              ns: 'documentManager',
                            })
                          : ''}
                      </span>
                    }
                    placement="top"
                    trigger={'hover'}
                    disabled={item.fromParent || fromOtherParent}
                  >
                    <div>
                      {item.selected
                        ? (i18n.t('active', {
                            ns: 'documentManager',
                          }) as string)
                        : messages.changePermissionTo(
                            permissionTitle,
                            index < activeIndex
                          )}
                    </div>
                  </APopover>
                  {item.selected && (
                    <span
                      style={{
                        display: 'flex',
                        flex: 1,
                        justifyContent: 'flex-end',
                      }}
                    >
                      <HoverIcon
                        type="trash"
                        color={red}
                        title={i18n.t('removePermission', {
                          ns: 'documentManager',
                        })}
                        onClick={this.handleClickOnItem(undefined)}
                        style={{
                          marginInlineStart: '5px',
                          cursor: 'pointer',
                          transform: 'scale(0.9)',
                        }}
                      />
                    </span>
                  )}
                </ButtonSpan>
              </>
            );
          })}
        </ButtonGroupWrapper>
        {loading ? (
          <div className="progress" style={{ margin: 0 }}>
            <div className="indeterminate" />
          </div>
        ) : (
          <div style={{ height: '4px', width: '100%' }} />
        )}
      </div>
    );
  }
}

export default ButtonGroup;
